__turbopack_context__.v({
  "article": "ArticleSection-module-scss-module__TuZxpG__article",
  "article-section": "ArticleSection-module-scss-module__TuZxpG__article-section",
  "button-group": "ArticleSection-module-scss-module__TuZxpG__button-group",
  "card-grid": "ArticleSection-module-scss-module__TuZxpG__card-grid",
  "show-more": "ArticleSection-module-scss-module__TuZxpG__show-more",
});
